var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _g2, _rect, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 61,
    viewBox: "0 0 33 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88037 42.2274C3.88037 41.1019 4.32745 40.0226 5.12326 39.2268C5.91907 38.431 6.99842 37.9839 8.12386 37.9839H25.0978C26.2233 37.9839 27.3026 38.431 28.0984 39.2268C28.8942 40.0226 29.3413 41.1019 29.3413 42.2274V45.0564C29.3413 46.1818 28.8942 47.2612 28.0984 48.057C27.3026 48.8528 26.2233 49.2999 25.0978 49.2999H8.12386C6.99842 49.2999 5.91907 48.8528 5.12326 48.057C4.32745 47.2612 3.88037 46.1818 3.88037 45.0564V42.2274Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5376 43.6416V43.655Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5376 43.6416V43.655",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1963 43.6416H23.6833Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1963 43.6416H23.6833",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88037 30.9115C3.88037 29.786 4.32745 28.7067 5.12326 27.9109C5.91907 27.115 6.99842 26.668 8.12386 26.668H25.0978C26.2233 26.668 27.3026 27.115 28.0984 27.9109C28.8942 28.7067 29.3413 29.786 29.3413 30.9115V33.7405C29.3413 34.8659 28.8942 35.9452 28.0984 36.7411C27.3026 37.5369 26.2233 37.9839 25.0978 37.9839H8.12386C6.99842 37.9839 5.91907 37.5369 5.12326 36.7411C4.32745 35.9452 3.88037 34.8659 3.88037 33.7405V30.9115Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53809 32.3257V32.3391Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53809 32.3257V32.3391",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1963 32.3257H23.6833Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1963 32.3257H23.6833",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88037 19.5951C3.88037 18.4696 4.32745 17.3903 5.12326 16.5945C5.91907 15.7986 6.99842 15.3516 8.12386 15.3516H25.0978C26.2233 15.3516 27.3026 15.7986 28.0984 16.5945C28.8942 17.3903 29.3413 18.4696 29.3413 19.5951V22.424C29.3413 23.5495 28.8942 24.6288 28.0984 25.4246C27.3026 26.2205 26.2233 26.6675 25.0978 26.6675H8.12386C6.99842 26.6675 5.91907 26.2205 5.12326 25.4246C4.32745 24.6288 3.88037 23.5495 3.88037 22.424V19.5951Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53809 21.0098V21.0232Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53809 21.0098V21.0232",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1963 21.0098H23.6833Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1963 21.0098H23.6833",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88037 8.27962C3.88037 7.15418 4.32745 6.07483 5.12326 5.27902C5.91907 4.48321 6.99842 4.03613 8.12386 4.03613H25.0978C26.2233 4.03613 27.3026 4.48321 28.0984 5.27902C28.8942 6.07483 29.3413 7.15418 29.3413 8.27962V11.1086C29.3413 12.2341 28.8942 13.3134 28.0984 14.1092C27.3026 14.905 26.2233 15.3521 25.0978 15.3521H8.12386C6.99842 15.3521 5.91907 14.905 5.12326 14.1092C4.32745 13.3134 3.88037 12.2341 3.88037 11.1086V8.27962Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53809 9.69385V9.70729Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53809 9.69385V9.70729",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1963 9.69385H23.6833Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1963 9.69385H23.6833",
    stroke: "black",
    strokeWidth: 0.938585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.859805,
    y: 0.642031,
    width: 31.502,
    height: 52.0531,
    rx: 6.99802,
    stroke: "black",
    strokeWidth: 1.12
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53862 52.9709V53.7861C8.53862 57.0977 5.85406 59.7823 2.54248 59.7823V59.7823",
    stroke: "black",
    strokeWidth: 1.12
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6655 52.7979V53.7865C24.6655 57.0981 27.35 59.7827 30.6616 59.7827V59.7827",
    stroke: "black",
    strokeWidth: 1.12
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53857 55.7393L24.6654 55.7393",
    stroke: "black",
    strokeWidth: 1.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRack2);
export default __webpack_public_path__ + "static/media/rack2.92b3a13ae91257a90b39e4e47eda74c3.svg";
export { ForwardRef as ReactComponent };